import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import api from '@/api';
import { isNullOrUndefined } from '@/utils/helpers';
import state from './state';
import { BULK_SET_ACTIONS_DATA, SET_ACTION_DATA } from './mutations';

const buildActionActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setActionData = buildActionActionObject('setActionData');
export const bulkSetActionsData = buildActionActionObject('bulkSetActionsData');
export const getActionData = buildActionActionObject('getActionData');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getActionData.action]({ dispatch }, payload) {
		const { id, forceGet } = payload;
		const dataIsMissing = isNullOrUndefined(state.data[id]);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			// 2022-20-24 api does not really have a "getAction" function. this store action is a fugazi, can remove it.
			const ret = await api.getAction(id);
			return await dispatch(setActionData.action, { data: ret });
		}
	},
	[setActionData.action]({ commit }, payload) {
		const { data: actionData } = payload;
		commit(SET_ACTION_DATA, { key: actionData.id, value: actionData });
	},
	[bulkSetActionsData.action]({ commit }, { data }) {
		commit(BULK_SET_ACTIONS_DATA, { data });
	},
};

export default actions;
